import Modal from "components/Common/Modal";
import useIsMobile from "hooks/useIsMobile";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { useTheme } from "@mui/material";
import {
  activateAppUpdate,
  checkRuntimeVersion,
  hasAttemptedRuntimeReload,
  subscribeToAppUpdates,
  type AppUpdate,
} from "services/appUpdate";
import { useUnsavedWork } from "hooks/UnsavedWorkContext";

const NewVersionPrompt = () => {
  const theme = useTheme();
  const [updateModal, setUpdateModal] = useState(false);
  const pendingUpdate = useRef<AppUpdate | null>(null);
  const { hasUnsavedWork } = useUnsavedWork();
  const { t } = useTranslation();

  useEffect(() => {
    const handleUpdate = (update: AppUpdate) => {
      pendingUpdate.current = update;
      const hasWaitingWorker = Boolean(update.registration?.waiting);
      const canAutoReload =
        hasWaitingWorker || !hasAttemptedRuntimeReload(update.version);

      if (hasUnsavedWork || !canAutoReload) setUpdateModal(true);
      else
        activateAppUpdate(update.registration, {
          broadcast: !update.fromOtherTab,
        });
    };

    const unsubscribe = subscribeToAppUpdates(handleUpdate);
    checkRuntimeVersion();
    const interval = window.setInterval(checkRuntimeVersion, 60_000);

    return () => {
      unsubscribe();
      window.clearInterval(interval);
    };
  }, [hasUnsavedWork]);
  const isMobile = useIsMobile();

  const modalOverlaySx = {
    backgroundColor: "white !important",
    width: "50%",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4ch",
    padding: "2ch 3ch",
    fontSize: `${theme.typography.fontSize}px !important`,
    fontFamily: `${theme.typography.fontFamily} !important`,

    fontWeight: "inherit !important",
  };

  return (
    <Modal
      message={`${t("new-version-available")}`}
      modalContentSx={{ height: "10vh !important" }}
      modalOverlaySx={modalOverlaySx}
      open={updateModal}
      onClose={() => setUpdateModal(false)}
      closeButton
      width={isMobile ? "98vw" : "500px"}
      primary={{
        variant: "contained",
        onClick: () => {
          activateAppUpdate(pendingUpdate.current?.registration, {
            broadcast: !pendingUpdate.current?.fromOtherTab,
          });
        },
        children: `${t("refresh")}`,
      }}
    />
  );
};
export default NewVersionPrompt;
